import AssessmentFlow from '@/components/assessment/AssessmentFlow';
import { usePortal } from '@/contexts/PortalContext';

const PortalAssessment = () => {
  const { config } = usePortal();
  return <AssessmentFlow config={config} />;
};

export default PortalAssessment;
